import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LinkWithSearchParams from "../Components/UI/LinkWithSearchParams";
import { getEllipsisTxt } from "../helpers/formatters";
import { BsFacebook, BsReply, BsTwitter } from "react-icons/bs";
import { FiShare2 } from "react-icons/fi";
import { HiDotsHorizontal } from "react-icons/hi";
import { IoIosCopy } from "react-icons/io";
import { MdReport } from "react-icons/md";
import { RiUserSettingsLine } from "react-icons/ri";
import { FaHandSparkles } from "react-icons/fa";

import Account from "../Components/Account/Account";
import Blockie from "../Components/UI/Blockie";
import HoverList from "../Components/UI/HoverList";
import LoadingBar from "../Components/UI/LoadingBar";

import { notify, showToast, walletConnectNotify } from "../utils/hot-toast";
import { useRpcURL, useStorageContractAddress } from "../hooks";

import { ReactComponent as BinanceCoin } from "../assets/images/launchpad/binance-coin.svg";
import {
    followProfile,
    getCallerDetails,
    getMyProfile,
    getNonceByWallet,
    getPresalesByOnwer,
    getProfileByUsername,
    likeArticle,
    likePresale,
    loadArticlesData,
    loadFollowersData,
    loadFollowingData,
    updateClientDetails,
    verifySignature,
} from "../utils/apis";

import PresaleABI from "../abis/ABI_Presale.json";
import ABI_StorageLaunchpad from "../abis/ABI_StorageLaunchpad.json";

import {
    PRESALE_CANCELED,
    PRESALE_ENDED,
    PRESALE_ENDED_NOT_MET_SOFTCAP,
    PRESALE_FILLED,
    PRESALE_FINALISED,
    PRESALE_INPROGRESS,
    PRESALE_UPCOMING,
} from "../utils/constants";
import LaunchPadCard from "../Components/LaunchPad/LaunchPadDashboard/LaunchPadCard";
import { TbHandClick, TbHandFinger } from "react-icons/tb";
import removeMarkdown from "markdown-to-text";

import { useStore } from "../utils/store";
import { BiMessageSquareDetail } from "react-icons/bi";

const Profile = () => {
    const fetchProfile = useStore((state) => state.fetchProfile);
    const myProfile = useStore((state) => state.profile);

    const navigate = useNavigate();
    const { username } = useParams();

    const { library, account, active, chainId } = useWeb3React();
    const HTTP_RPC_URL = useRpcURL();
    const STORAGE_CONTRACT_ADDRESS = useStorageContractAddress();
    const [searchParams] = useSearchParams();

    const currentTab = searchParams.get("tab") || "presales";

    const [profile, setProfile] = useState(null);
    const [followers, setFollowers] = useState([]);
    const [following, setFollowing] = useState([]);
    const [posts, setPosts] = useState([]);

    const [cancelled, setCancelled] = useState(false);
    const [mainLoading, setMainLoading] = useState(false);
    const [presaleArray, setPresaleArray] = useState([]);

    useEffect(() => {
        loadProfile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account, username]);
    const loadProfile = async () => {
        // load my profile
        if (username === undefined) {
            const _profile = await getMyProfile(account);
            setProfile(_profile);
            return;
        }

        // load others profile
        const _profile = await getProfileByUsername(username);
        setProfile(_profile);
    };
    useEffect(() => {
        const provider = new Web3(
            new Web3.providers.HttpProvider(HTTP_RPC_URL)
        );
        window.web3 = new Web3(provider);

        if (profile?.verified === true) {
            if (currentTab === "presales") loadPresales();
            if (currentTab === "posts") loadPosts();
            if (currentTab === "followers") loadFollowers();
            if (currentTab === "following") loadFollowing();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTab, account, profile, HTTP_RPC_URL]);

    const signForPostProfile = async () => {
        setMainLoading(true);
        try {
            const web3 = new Web3(library.provider);
            window.web3 = web3;

            const [nonce, clientInfo] = await Promise.all([
                getNonceByWallet(account),
                getCallerDetails(),
            ]);

            const signatureHash = await web3.eth.personal.sign(nonce, account);
            const result = await verifySignature(account, signatureHash);
            if (result.verified === true) {
                showToast("SUCCESS", "Signature was verified successfully!");
                setMainLoading(false);
                setProfile(result);
                updateClientDetails(account, clientInfo, signatureHash);
                fetchProfile(account);
                return;
            }
            showToast("ERROR", "Signature verfication failed!");
            setMainLoading(true);
        } catch (error) {
            showToast("ERROR", "Signature verfication failed!");
            setMainLoading(false);
        }
    };
    const loadPresales = async () => {
        setMainLoading(true);
        const web3 = window.web3;
        const presales = await getPresalesByOnwer(
            profile.wallet,
            chainId || 56
        );

        const _storageContract = new web3.eth.Contract(
            ABI_StorageLaunchpad,
            STORAGE_CONTRACT_ADDRESS
        );

        const presaleAddresses = presales.map((presale) => presale.address);
        const presaleContracts = presaleAddresses.map(
            (address) => new web3.eth.Contract(PresaleABI, address)
        );

        const [
            presaleStateArr,
            finalizedArr,
            contributionArr,
            progressArr,
            projectStoreArr,
        ] = await Promise.all([
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.presaleState().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.finalized().call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.getContribution(account).call()
                )
            ),
            Promise.all(
                presaleContracts.map((_presaleContract) =>
                    _presaleContract.methods.weiRaised().call()
                )
            ),
            Promise.all(
                presaleAddresses.map((address) =>
                    _storageContract.methods.ProjectStoreByOwner(address).call()
                )
            ),
        ]);
        presaleStateArr.forEach(
            (item, index) => (presaleStateArr[index] = parseInt(item))
        );

        let _array = [];

        presales.forEach((presale, index) => {
            let _item = {
                index,
                cardId: index,
                offChainData: presale,
                presaleAddress: presaleAddresses[index],
                audit: "",
                name: presale.name,
                presaleState: presaleStateArr[index],
                finalized: finalizedArr[index],
                con: contributionArr[index],
                minCon: window.web3.utils.fromWei(
                    presale.minContribution.toString(),
                    "ether"
                ),
                maxCon: window.web3.utils.fromWei(
                    presale.maxContribution.toString(),
                    "ether"
                ),
                softCap: presale.hardCap / 2,
                hardCap: presale.hardCap,
                progress: window.web3.utils.fromWei(
                    progressArr[index].toString(),
                    "ether"
                ),
                liquidity: presale.liquidityPercentage,
                lockupTime: presale.liquidityLockupTime,
                presaleStartTime: parseInt(presale.presaleStartTime),
                presaleEndTime: parseInt(presale.presaleEndTime),
                projectStore: projectStoreArr[index],
            };
            const currentTime = parseInt(new Date().getTime() / 1000);
            if (_item.finalized === true) {
                _item.status = PRESALE_FINALISED;
            } else if (_item.progress >= _item.hardCap - _item.minCon)
                _item.status = PRESALE_FILLED;
            else if (currentTime < _item.presaleStartTime)
                _item.status = PRESALE_UPCOMING;
            else if (currentTime < _item.presaleEndTime) {
                if (_item.presaleState === 0) _item.status = PRESALE_CANCELED;
                else {
                    // _item.status = PRESALE_ENDED;
                    _item.status = PRESALE_INPROGRESS;
                }
            } else {
                //time ended
                if (_item.progress < _item.softCap)
                    _item.status = PRESALE_ENDED_NOT_MET_SOFTCAP;
                else if (_item.presaleState === 0) {
                    _item.status = PRESALE_CANCELED;
                } else _item.status = PRESALE_ENDED;
            }

            _array.push(_item);
        });
        setMainLoading(false);
        setPresaleArray(
            _array.sort((a, b) => b.presaleStartTime - a.presaleStartTime)
        );
    };

    const loadPosts = async () => {
        setMainLoading(true);
        const _posts = await loadArticlesData(profile.wallet || account);
        setPosts(_posts);
        setMainLoading(false);
    };
    const loadFollowers = async () => {
        setMainLoading(true);
        const _followers = await loadFollowersData(
            username || profile.username
        );
        if (_followers.length) setFollowers(_followers);
        setMainLoading(false);
    };

    const loadFollowing = async () => {
        setMainLoading(true);
        const _following = await loadFollowingData(
            username || profile.username
        );
        if (_following.length) setFollowing(_following);
        setMainLoading(false);
    };

    const likeHandler = async (presaleAddress) => {
        // console.log(presaleAddress, account);
        const offChainData = await likePresale(presaleAddress, account);
        const updatedLauchpadArray = presaleArray.map((item) => {
            if (
                item.presaleAddress.toLowerCase() !==
                presaleAddress.toLowerCase()
            )
                return item;
            else {
                item.offChainData = offChainData;
                return item;
            }
        });
        setPresaleArray(updatedLauchpadArray);
    };

    const followHandler = async () => {
        if (!account) {
            showToast("error", "You need to register profile to follow him!");
            return;
        }
        if (!profile) return;
        try {
            const result = await followProfile(profile.username, account);
            if (result.statusCode === 400) {
                showToast("error", result.message);
                return;
            }
            if (result) {
                showToast("SUCCESS", "Updated successfully!");
                setProfile(result);
                return;
            }
        } catch (error) {
            showToast("error", "Error while handling your request!");
        }
    };

    const likeToggleArticle = async (id) => {
        if (!account) {
            walletConnectNotify();
            return;
        }
        try {
            const _updatedPost = await likeArticle(id, account);
            setPosts(
                posts.map((post) =>
                    post._id === _updatedPost._id ? _updatedPost : post
                )
            );
            if (_updatedPost.likes.includes(account)) {
                notify(
                    "success",
                    <FaHandSparkles className="w-16 h-16 animation-enter" />,
                    "Like Post!",
                    "Successfully clapped this article"
                );
                return;
            }
            showToast("info", "Successfully unclapped this article.", null);
        } catch (error) {
            showToast(
                "error",
                "Error occured while clapping article.",
                null,
                "Something went wrong!"
            );
        }
    };

    const shareOptions = {
        icon: <FiShare2 className="size-1" />,
        options: [
            {
                icon: <IoIosCopy className="size-2" />,
                text: "Copy Link",
                handler: () => {
                    navigator.clipboard.writeText(
                        `${window.location.origin}/profile/${profile?.username}`
                    );
                    showToast(
                        "SUCCESS",
                        "Profile link was copied to clipboard!"
                    );
                },
            },
            {
                icon: <BsFacebook className="size-2" />,
                text: "Share on Facebook",
                handler: () => {
                    const shareLink = `https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}/profile/${profile?.username}`;
                    window.open(shareLink, "_blank").focus();
                },
            },
            {
                icon: <BsTwitter className="size-2" />,
                text: "Share on Twitter",
                handler: () => {
                    const shareLink = `https://twitter.com/intent/tweet?text=Check out this account on Kadido&url=${window.location.origin}/profile/${profile?.username}&via=kadido`;
                    window.open(shareLink, "_blank").focus();
                },
            },
        ],
    };
    const extraOptions = {
        icon: <HiDotsHorizontal className="size-1" />,
        options: [
            account === profile?.wallet
                ? {
                      icon: <RiUserSettingsLine className="size-2" />,
                      text: "Settings",
                      handler: () => {
                          navigate("/profile/settings");
                      },
                  }
                : null,
            account !== profile?.wallet
                ? {
                      icon: <MdReport className="size-2" />,
                      text: "Report",
                      handler: () => {
                          alert(account);
                      },
                  }
                : null,
        ],
    };

    const tabLinks = [
        {
            link: "/profile",
            tab: "presales",
            text: `Presales (${profile?.presaleNumber})`,
        },
        {
            link: "/profile",
            tab: "posts",
            text: `Posts (${profile?.articleNumber})`,
        },
        {
            link: "/profile",
            tab: "followers",
            text: `Followers (${profile?.followers.length})`,
        },
        {
            link: "/profile",
            tab: "following",
            text: `Following (${profile?.following.length})`,
        },
    ];

    const presalesPanel = () => {
        return (
            <div className="flex flex-col md:flex-row justify-center gap-x-8">
                {mainLoading ? (
                    <LoadingBar text="Loading Presales..." />
                ) : presaleArray.length === 0 ? (
                    <span className="size-4 w-full text-center border border-kadComponentBorder rounded-lg py-24 font-bold tracking-wider">
                        No items to display
                    </span>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 w-full gap-x-8 gap-y-8 2xl:gap-x-8 2xl:gap-y-12">
                        {presaleArray.map((el, i) => (
                            <LaunchPadCard
                                key={i}
                                {...el}
                                likeHandler={likeHandler}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const postsPanel = () => {
        return (
            <div className="flex flex-col md:flex-row justify-center gap-x-8">
                {mainLoading ? (
                    <LoadingBar text="📰 Loading Posts..." />
                ) : (
                    <div className="flex flex-col w-full">
                        {posts
                            .filter((post) => !post.thread)
                            .map((post, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col pt-4 pb-2 border-b-2 border-kadComponentBg"
                                >
                                    <span className="opacity-50 font-normal size-sm">
                                        {new Date(
                                            post?.createdAt
                                        ).toLocaleDateString("en-US", {})}
                                    </span>
                                    <LinkWithSearchParams
                                        to={{ pathname: `/feeds/${post.link}` }}
                                        // className="size-2 py-4 hover:opacity-70 duration-150"
                                    >
                                        {/* {post.subject} */}
                                        <span className="preview-article-content">
                                            {removeMarkdown(post?.markdown)}
                                        </span>

                                        {post?.giphyLink?.length > 0 && (
                                            <img
                                                alt="giphy attachment"
                                                src={post?.giphyLink}
                                                className="animation-enter w-full mt-4"
                                            />
                                        )}
                                    </LinkWithSearchParams>
                                    <div className="flex gap-2 pt-4 items-center">
                                        {post.tags.map((tag, index) => (
                                            <LinkWithSearchParams
                                                key={index}
                                                className="article-tag"
                                                to={{
                                                    pathname: `/posts/tag/${tag}`,
                                                }}
                                            >
                                                {tag}
                                            </LinkWithSearchParams>
                                        ))}
                                        <span className="ml-2 font-light opacity-70">
                                            {Math.ceil(
                                                post.markdown.length / 1000
                                            )}{" "}
                                            mins read
                                        </span>
                                        {post.likes.includes(account) ? (
                                            <TbHandClick
                                                className="ml-auto size-2 cursor-pointer hover:fill-transparent fill-kadGrSt duration-150"
                                                onClick={() =>
                                                    likeToggleArticle(post._id)
                                                }
                                            />
                                        ) : (
                                            <TbHandFinger
                                                className="ml-auto size-2 cursor-pointer hover:stroke-kadGrSt duration-150"
                                                onClick={() =>
                                                    likeToggleArticle(post._id)
                                                }
                                            />
                                        )}
                                        {post.likes.length}

                                        <BiMessageSquareDetail className="ml-4 mr-1 size-2 cursor-pointer hover:fill-kadGrSt duration-150" />
                                        <span>{post.replyNumber}</span>

                                        <LinkWithSearchParams
                                            to={{
                                                pathname: `/feeds/${post.link}`,
                                            }}
                                        >
                                            <BsReply className="ml-4 mr-1 size-2 cursor-pointer hover:fill-kadGrSt duration-150" />
                                        </LinkWithSearchParams>
                                    </div>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        );
    };

    const followersPanel = () => {
        return (
            <div className="flex flex-col gap-x-8">
                {mainLoading ? (
                    <LoadingBar text="Loading followers list ..." />
                ) : (
                    <div className="flex flex-col">
                        {followers.map((follower, index) => (
                            <div
                                key={index}
                                className="flex flex-row py-4 border-b-2 border-kadComponentBg items-center md:items-start"
                            >
                                {follower.avatarLink ? (
                                    <img
                                        className="w-16 md:w-24 h-16 md:h-24 rounded-full ring-4 ring-kadComponentBg"
                                        src={follower.avatarLink}
                                        alt="profile avatar"
                                    />
                                ) : (
                                    <Blockie
                                        address={follower.wallet}
                                        className="rounded-full ring-4 ring-kadComponentBg"
                                        scale={11}
                                    />
                                )}
                                <div className="flex flex-col ml-4">
                                    <span className="mt-2 size-1">
                                        <LinkWithSearchParams
                                            className="hover:opacity-70"
                                            to={{
                                                pathname: `/profile/${follower.username}`,
                                            }}
                                        >
                                            {follower.username}
                                        </LinkWithSearchParams>
                                        <span className="ml-4 size-base mt-3 opacity-50">
                                            {getEllipsisTxt(follower?.wallet)}
                                        </span>
                                    </span>
                                    <span className="w-full size-sm opacity-50">
                                        {follower.bio}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };
    const followingPanel = () => {
        return (
            <div className="flex flex-col gap-x-8">
                {mainLoading ? (
                    <LoadingBar text="Loading followers list ..." />
                ) : (
                    <div className="flex flex-col">
                        {following.map((follower, index) => (
                            <div
                                key={index}
                                className="flex flex-row py-4 border-b-2 border-kadComponentBg items-center md:items-start"
                            >
                                {follower.avatarLink ? (
                                    <img
                                        className="w-16 md:w-24 h-16 md:h-24 rounded-full ring-4 ring-kadComponentBg"
                                        src={follower.avatarLink}
                                        alt="profile avatar"
                                    />
                                ) : (
                                    <Blockie
                                        address={follower.wallet}
                                        className="rounded-full ring-4 ring-kadComponentBg"
                                        scale={11}
                                    />
                                )}
                                <div className="flex flex-col ml-4">
                                    <span className="mt-2 size-1">
                                        <LinkWithSearchParams
                                            className="hover:opacity-70"
                                            to={{
                                                pathname: `/profile/${follower.username}`,
                                            }}
                                        >
                                            {follower.username}
                                        </LinkWithSearchParams>
                                        <span className="ml-4 size-base mt-3 opacity-50">
                                            {getEllipsisTxt(follower?.wallet)}
                                        </span>
                                    </span>
                                    <span className="w-full size-sm opacity-50">
                                        {follower.bio}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    if ((active === false || cancelled === true) && username === undefined)
        return (
            <div className="main-container animation-fade-in flex flex-col">
                <h3 className="text-center">Connect your wallet</h3>
                <h5 className="page-subtitle">
                    If you don't have a wallet yet, you can select a provider
                    and create one now.
                </h5>
                <Account
                    additionalHandler={() => setCancelled(false)}
                    modalstyle={false}
                    buttonclassname="thiGr-button rounded-lg mx-auto size-1"
                />
            </div>
        );
    if (
        (myProfile === null || myProfile?.verified === false) &&
        username === undefined
    )
        return (
            <div className="main-container animation-fade-in flex flex-col">
                <h3 className="text-center">Accept and Sign</h3>
                <h5 className="page-subtitle">
                    By connecting your wallet and using Kadido, you agree to our
                    Terms of Service and Privacy Policy.
                </h5>
                {mainLoading ? (
                    <LoadingBar text="Verifying Signature..." />
                ) : (
                    <div className="flex justify-center gap-8">
                        <button
                            className="secGr-button w-40 py-3 size-base font-semibold"
                            onClick={() => setCancelled(true)}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={signForPostProfile}
                            className="thiGr-button w-40 py-3 size-base font-semibold"
                        >
                            Accept
                        </button>
                    </div>
                )}
            </div>
        );

    if (profile === null && username !== undefined)
        return (
            <div className="main-container animation-fade-in relative">
                <div className="md:bg-kadItemDarkBg relative shadow-lg mx-auto w-full lg:w-1/2 rounded-lg py-8 flex flex-col items-center">
                    <h2 className="page-title">404</h2>
                    <h4 className="opacity-70 mt-4">This page is lost.</h4>
                    <LinkWithSearchParams
                        to={{
                            pathname: "/",
                        }}
                        className="mt-8 size-1 rounded-full px-4 py-2 font-normal border border-kadComponentBorder hover:bg-kadComponentBorder duration-150 cursor-pointer"
                    >
                        Back to Home
                    </LinkWithSearchParams>
                </div>
            </div>
        );
    return (
        <div className="animation-fade-in flex flex-col pt-[25vw] lg:pt-[20vw] pb-16">
            <div
                className="absolute right-0 top-[70px] w-full aspect-[4/1] lg:aspect-[5/1] bg-kadItemDarkBg bg-cover"
                style={
                    profile?.bannerLink && {
                        backgroundImage: `url("${profile?.bannerLink}")`,
                    }
                }
            />
            <div className="w-full flex flex-col relative pt-12 lg:pt-10">
                {profile?.avatarLink ? (
                    <img
                        className="profile-blockie"
                        alt="Profile Avatar"
                        src={profile.avatarLink}
                    />
                ) : (
                    <Blockie
                        address={profile?.wallet}
                        className="profile-blockie"
                        scale={25}
                    />
                )}
                <div className="flex items-center">
                    <h3>{profile?.username}</h3>
                    {profile?.followers && (
                        <button
                            onClick={followHandler}
                            className="profile-follow "
                        >
                            {profile?.followers?.includes(account)
                                ? "Following"
                                : "Follow"}
                        </button>
                    )}
                    <div className="flex gap-2 ml-auto">
                        <HoverList {...shareOptions} />
                        <HoverList {...extraOptions} />
                    </div>
                </div>
                <div className="flex items-center flex-wrap">
                    <BinanceCoin />
                    <span
                        className="ml-2 cursor-pointer hover:opacity-70"
                        title="Copy"
                        onClick={() => {
                            navigator.clipboard.writeText(profile?.wallet);
                        }}
                    >
                        {getEllipsisTxt(profile?.wallet)}
                    </span>
                    <span className="w-full md:w-fit md:ml-2 text-kadComponentFocus">
                        Joined{" "}
                        {new Date(profile?.createdAt).toLocaleDateString(
                            "en-US",
                            {}
                        )}
                    </span>
                </div>
                <div className="flex gap-4 md:gap-8 my-8 size-base md:size-lg">
                    {tabLinks.map((tabLink, key) => {
                        return (
                            <LinkWithSearchParams
                                className={`${
                                    tabLink.tab === currentTab
                                        ? "text-white border-b-2"
                                        : "text-kadComponentFocus"
                                } py-2 tracking-wider font-bold`}
                                to={{
                                    pathname: `${tabLink.link}${
                                        username ? `/${username}` : ""
                                    }`,
                                    search: `&tab=${tabLink.tab}`,
                                }}
                                key={key}
                            >
                                {tabLink.text}
                            </LinkWithSearchParams>
                        );
                    })}
                </div>
                {currentTab === "presales" && presalesPanel()}
                {currentTab === "posts" && postsPanel()}
                {currentTab === "followers" && followersPanel()}
                {currentTab === "following" && followingPanel()}
            </div>
        </div>
    );
};
export default Profile;
